import {CSSProperties, FC} from 'react';


export interface IIconBatteryProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconBattery: FC<IIconBatteryProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="M18.89 5.406h-1.054V4H14.32v1.406H9.68V4H6.164v1.406H5.11C3.946 5.406 3 6.352 3 7.516v9.375C3 18.054 3.946 19 5.11 19h13.78c1.164 0 2.11-.946 2.11-2.11V7.517c0-1.164-.946-2.11-2.11-2.11Zm.704 11.485a.704.704 0 0 1-.703.703H5.109a.704.704 0 0 1-.703-.703V7.516c0-.388.316-.704.703-.704h13.782c.387 0 .703.316.703.704v9.375ZM11.6 11.699h2.881l-1.884 3.973-1.23.703v-1.336l.936-1.934h-2.8l1.828-4.464h1.536l-1.267 3.058Z" />
        </svg>
    );
};
